import api from './api';

const ruleQ = (ruleId) => (ruleId ? `?ruleId=${ruleId}` : '');

const rateCodeService = {
    list:    (ppId, ruleId)            => api.get(`/paymentporter/${ppId}/rate-codes${ruleQ(ruleId)}`),
    getById: (ppId, rateCodeId)        => api.get(`/paymentporter/${ppId}/rate-codes/${rateCodeId}`),
    create:  (ppId, data, ruleId)      => api.post(`/paymentporter/${ppId}/rate-codes${ruleQ(ruleId)}`, data),
    update:  (ppId, rateCodeId, data)  => api.put(`/paymentporter/${ppId}/rate-codes/${rateCodeId}`, data),
    remove:  (ppId, rateCodeId)        => api.delete(`/paymentporter/${ppId}/rate-codes/${rateCodeId}`),
};

export default rateCodeService;
